<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="អតិថិជនទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
			</div>

			<md-table v-if="clientList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>លេខទូរស័ព្ទ</md-table-head>
					<md-table-head>គណនីធនាគារ</md-table-head>
					<md-table-head>តេឡេក្រាម</md-table-head>
					<md-table-head>កំណត់ចំណាំ</md-table-head>
					<md-table-head>អ្នកទីផ្សារ</md-table-head>
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
						{{ client.hash_id }}
					</md-table-cell>
					<md-table-cell>{{ client.name }}</md-table-cell>
					<md-table-cell>{{ client.phone }}</md-table-cell>
					<md-table-cell>
						<div class="bank-row">
							<img :src="config.getProfileUrl(client.bank_usd)" class="bank-image" />
							<img :src="config.getProfileUrl(client.bank_khr)" class="bank-image"  />
						</div>
					</md-table-cell>
					<md-table-cell>
						<img :src="config.getProfileUrl(client.telegram_qr)" class="bank-image"  />
					</md-table-cell>
					<md-table-cell>{{ client.note }}</md-table-cell>
					<md-table-cell>
						<span v-if="client.referral_name != null">{{ client.referral_name }}</span>
						<span v-else>មិនមាន</span>
				</md-table-cell>
					<md-table-cell>{{ config.datelify(client.created_date) }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/detail/' + client.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/clients/edit/' + client.hash_id">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រព័ត៌មាន</md-tooltip>
							</md-button>
						</router-link>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientList.length == 0 && loadMore == true">មិនមានអតិថិជន</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអតិថិជន</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ឈ្មោះអតិថិជន *</label>
								<md-input type="text" v-model="client.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>លេខទូរស័ព្ទអតិថិជន *</label>
								<md-input type="text" v-model="client.phone"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>កំណត់សំគាល់</label>
								<md-input type="text" v-model="client.description">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<label>អ្នកទីផ្សារ *</label>
							<v-select label="name" inputId="id" :clearable="false" :options="referralList"
								v-model="client.referralArray">
							</v-select>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50 text-center">
							<div style="width:100%">
								<p>គណនី USD *</p>
								<input type="file" ref="image_usd" accept="image/*" style="display: none;" @change="processFileUSD($event)">
								<img class="thumb-profile" :src="config.getProfileUrl()" v-if="client.bank_usd.length == 0">
								<img class="thumb-profile" :src="config.getProfileUrl(client.bank_usd)" v-if="client.bank_usd.length > 0">
							</div>
							<md-button class="md-primary" @click="openUSD()" v-if="client.bank_usd.length == 0">បញ្ចូលរូបភាព</md-button>
							<md-button class="md-danger" @click="removeUSD()" v-else>លុបចោល</md-button>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50 text-center">
							<div style="width:100%">
								<p>គណនី KHR *</p>
								<input type="file" ref="image_khr" accept="image/*" style="display: none;" @change="processFileKHR($event)">
								<img class="thumb-profile" :src="config.getProfileUrl()" v-if="client.bank_khr.length == 0">
								<img class="thumb-profile" :src="config.getProfileUrl(client.bank_khr)" v-if="client.bank_khr.length > 0">
							</div>
							<md-button class="md-primary" @click="openKHR()" v-if="client.bank_khr.length == 0">បញ្ចូលរូបភាព</md-button>
							<md-button class="md-danger" @click="removeKHR()" v-else>លុបចោល</md-button>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50 text-center">
							<div style="width:100%">
								<p>គណនី Telegram</p>
								<input type="file" ref="image_telegram" accept="image/*" style="display: none;" @change="processFileTelegram($event)">
								<img class="thumb-profile" :src="config.getProfileUrl()" v-if="client.telegram_qr.length == 0">
								<img class="thumb-profile" :src="config.getProfileUrl(client.telegram_qr)" v-if="client.telegram_qr.length > 0">
							</div>
							<md-button class="md-primary" @click="openTelegram()" v-if="client.telegram_qr.length == 0">បញ្ចូលរូបភាព</md-button>
							<md-button class="md-danger" @click="removeTelegram()" v-else>លុបចោល</md-button>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះអតិថិជន</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.name).length > 0">{{client.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>អ្នកទីផ្សារ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.referral_id).length > 0">{{client.referralArray.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់សំគាល់</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.description).length > 0">{{client.description}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postClient()">បង្កើត</md-button>
				</div>
			</div>

		</div>
	</div>

	<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			this.getReferral();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: ""
				},
				client: {
					name: "",
					phone: "",
					description: "",
					bank_usd: "",
					bank_khr: "",
					telegram_qr: "",
					referral_id: "",
					referralArray: ""
				},
				loadMore: true,
				clientList: [],
				referralList: []

			}
		},
		watch: {
			'client.referralArray': function (val) {
				if (String(this.client.referralArray).length > 5) {
					this.client.referral_id = this.client.referralArray.id;
				} else {
					this.client.referral_id = "";
				}
			}
		},
		methods: {
			postClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/post", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "អ្នកផ្ញើរឥវ៉ាន់ត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.searchHandler();
						this.clearAll();
					}
					// this.loadMoreCompanyButton = true

				})
			},
			getReferral() {
				this.$http.post(this.config.api + "/admin/referral/search", {
					text: "",
					offset: 0
				}).then(data => {
					this.referralList = data.body.data;
					// this.referralList = data.body.data;
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.clientList = more ? this.clientList.concat(data.body.data) : data.body.data;
					// this.clientList = data.body.data;
				})
			},
			checkValidation() {
				if (String(this.client.name).length > 0 && String(this.client.phone).length > 0 && String(this.client.bank_usd).length > 0 && String(this.client.bank_khr).length > 0 && String(this.client.telegram_qr).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},

			processFileUSD(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/client/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.client.bank_usd = res.body.data.image_id;
					}
				})
			},
			processFileKHR(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/client/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.client.bank_khr = res.body.data.image_id;
					}
				})
			},
			processFileTelegram(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/client/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.client.telegram_qr = res.body.data.image_id;
					}
				})
			},
			openUSD() {
				this.$refs['image_usd'].click();
			},
			openKHR() {
				this.$refs['image_khr'].click();
			},
			openTelegram() {
				this.$refs['image_telegram'].click();
			},
			removeUSD(id) {
				this.client.bank_usd = "";
			},
			removeKHR(id) {
				this.client.bank_khr = "";
			},
			removeTelegram(id) {
				this.client.telegram_qr = "";
			},
			clearAll() {
				this.search.text = "";
				this.client = {
					name: "",
					phone: "",
					description: "",
					bank_usd: "",
					bank_khr: "",
					telegram_qr: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}
	.thumb-profile {
		width: 70% !important;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
	.bank-row {
		display: flex;
		justify-content: center;
	}
	.bank-image {
		width: 50px !important;
		margin-left: 3px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/View.vue